import EnterpriseApiService from "src/api/EnterpriseApiService";
import { queryOptions } from "./v4QueryOptions/queryOptions"

export const getAllUnusedDBIoTDevicesQueryOptions = () => {
    return queryOptions({
        queryKey: ["getAllUnusedDBIoTDevicesQuery"],
        enabled: true,
        refetchOnWindowFocus: false,
        queryFn: async (q) => {

            return await EnterpriseApiService.getUnusedIotDevicesForBin(q.signal);
        }
    });
}